module.exports = __webpack_public_path__ + "static/img/1.ffcebab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/5/eng/1.png
// module id = SjY8
// module chunks = 0